import React from "react";

const RING_STYLES = [
  {
    cls: "parallax-layer animate-slow-spin animate-ring-pulse-outer",
    style: {
      width: "min(92vmin, 820px)",
      height: "min(92vmin, 820px)",
      border: "1px solid rgba(212,175,55,0.06)",
      borderRadius: "50%",
      "--depth": "10px",
    },
  },
  {
    cls: "parallax-layer animate-ring-pulse-mid",
    style: {
      width: "min(70vmin, 620px)",
      height: "min(70vmin, 620px)",
      border: "1px solid rgba(212,175,55,0.10)",
      borderRadius: "50%",
      "--depth": "16px",
    },
  },
  {
    cls: "parallax-layer animate-ring-pulse-inner",
    style: {
      width: "min(48vmin, 440px)",
      height: "min(48vmin, 440px)",
      border: "1px solid rgba(212,175,55,0.14)",
      borderRadius: "50%",
      "--depth": "24px",
      boxShadow: "inset 0 0 80px rgba(212,175,55,0.06)",
    },
  },
];

const HeroRings = () => (
  <>
    {RING_STYLES.map((ring, i) => (
      <div
        key={`ring-${i}`}
        className="absolute inset-0 flex items-center justify-center pointer-events-none"
      >
        <div className={ring.cls} style={ring.style} />
      </div>
    ))}
  </>
);

export default HeroRings;
